import { render, staticRenderFns } from "./WarnReasonEdit.vue?vue&type=template&id=5ab15db2&scoped=true"
import script from "./WarnReasonEdit.vue?vue&type=script&lang=js"
export * from "./WarnReasonEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab15db2",
  null
  
)

export default component.exports